interface LessonsListProps {
  selectedLesson: number | null;
  onSelectLesson: (lesson: number) => void;
}

export default function LessonsList({ selectedLesson, onSelectLesson }: LessonsListProps) {
  const lessons = [
    {
      number: 1,
      title: 'Planos y Ejes de Movimiento',
      duration: '35 min'
    },
    {
      number: 2,
      title: 'Tipos de Articulaciones',
      duration: '40 min'
    },
    {
      number: 3,
      title: 'Palancas Biomecánicas',
      duration: '45 min'
    },
    {
      number: 4,
      title: 'Torque y Brazo de Momento',
      duration: '50 min'
    },
    {
      number: 5,
      title: 'Curvas de Fuerza',
      duration: '40 min'
    },
    {
      number: 6,
      title: 'Biomecánica de Ejercicios Clave',
      duration: '60 min'
    }
  ];

  return (
    <div className="bg-white rounded-2xl p-6 border border-gray-200">
      <h3 className="text-xl font-bold text-black mb-6">Contenido del Módulo</h3>
      
      <div className="space-y-2">
        {lessons.map((lesson) => (
          <button
            key={lesson.number}
            onClick={() => onSelectLesson(lesson.number)}
            className={`w-full text-left p-4 rounded-xl transition-all cursor-pointer ${
              selectedLesson === lesson.number
                ? 'bg-[#1A3A2E] text-white'
                : 'bg-[#F5F2EB] text-gray-700 hover:bg-[#E8E5DD]'
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3 flex-1">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                    selectedLesson === lesson.number
                      ? 'bg-[#39FF14] text-black'
                      : 'bg-white text-[#1A3A2E]'
                  }`}
                >
                  <span className="text-sm font-bold">{lesson.number}</span>
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-sm leading-tight mb-1">
                    {lesson.title}
                  </h4>
                  <p
                    className={`text-xs ${
                      selectedLesson === lesson.number ? 'text-gray-300' : 'text-gray-500'
                    }`}
                  >
                    {lesson.duration}
                  </p>
                </div>
              </div>
              <i
                className={`ri-arrow-right-s-line text-xl flex-shrink-0 ${
                  selectedLesson === lesson.number ? 'text-[#39FF14]' : 'text-gray-400'
                }`}
              ></i>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}